<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("autoemailreport") }}</div>
      <router-link
        v-if="$can('create', 'Auto Email Report')"
        class="btn-blue"
        to="add-auto-email-report"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              this.GetAllAutoEmailReport(filterIsActive);
            }
          "
        />
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th class="text-left ml-2">
              <img
                v-if="this.columnName != 'email_id'"
                @click="onSortValue('email_id', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('email_id', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('email_id', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("email") }} {{ $t("address") }}
            </th>
            <th class="text-left ml-2">{{ $t("report") }} {{ $t("name") }}</th>
          </tr>
        </thead>
        <tbody v-if="emailreoprtList.length > 0">
          <tr
            v-for="(emailreport, emailreportIndex) in emailreoprtList"
            :key="emailreportIndex"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    emailreport.aec_is_active === 'Y'
                      ? 'active'
                      : emailreport.aec_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Auto Email Report')"
                    v-on:click="onEmailReport('Edit', emailreport)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    emailreport.aec_is_active === 'Y' ? 'active' : 'inactive'
                  "
                />
                <i
                  v-if="$can('update', 'Auto Email Report')"
                  v-on:click="onEmailReport('Edit', emailreport)"
                  class="edit-pen icon blue-icon ml-4"
                  style="cursor: pointer"
                  tabindex="0"
                  v-b-tooltip="'Edit'"
                ></i>
              </div>
            </td>

            <td class="text-left">{{ emailreport.email_id }}</td>
            <td class="text-left">{{ emailreport.rl_name }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      viewingnumbers: [],
      emailreoprtList: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.GetAllAutoEmailReport();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetAllAutoEmailReport();
      } else {
        this.currentPage = event;
        this.GetAllAutoEmailReport();
      }
    },

    onEmailReport: function (type, data) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-auto-email-report",
          query: { aec_id: data.aec_id },
        });
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.GetAllAutoEmailReport();
    },

    GetAllAutoEmailReport: function (filter_is_active = "Y") {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: filter_is_active,
      };

      MasterService.GetAutoEmailReport(body).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.emailreoprtList = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailReportComponents/listautoemailreport.vue